<template>
  <div class="mx-auto">
    <v-card flat class="pa-2">
      <v-card-text>
        <v-container>
          <div class="font-weight-medium black--text mb-1" style="font-size: 20px">
            Lengkapi Peserta Kelas
          </div>
          <p class="body-2 mb-7 mt-2">
            Jumlah peserta dalam kelas <strong>minimal {{ min }} sekolah ({{ min * 2 }} peserta)</strong> dan
            <strong>maksimal {{ maxLabel }} sekolah ({{ maxLabel * 2 }} peserta).</strong> Dalam kelas sebaiknya
            dimasukkan untuk jenjang yang sama. Jika kondisi tidak memungkinkan, sehingga dimasukkan beda jenjang.
            Sebisa mungkin, jenjangnya berdekatan. Misal PAUD dengan SD, SMP dengan SMA, dst.
          </p>
          <v-row>
            <v-col cols="12" lg="6" class="my-auto title black--text">
              <span class="font-weight-medium info--text">{{ sekolah.length }}</span> sekolah terpilih
            </v-col>
            <v-col cols="12" lg="6">
              <div class="text-right">
                <v-btn color="primary" class="ml-2" :disabled="sekolah.length >= max" depressed @click="onAdd">
                  <v-icon left dark class="mr-1">
                    mdi-plus
                  </v-icon>
                  Sekolah
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-list>
            <div v-for="(item, id) in sekolah" :key="id">
              <v-divider v-if="id > 0" />
              <v-list-item :key="id">
                <v-list-item-avatar color="blue">
                  <v-icon dark>mdi-home</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12" lg="4">
                      <v-label color="caption">
                        <small>Sekolah</small>
                      </v-label>
                      <div class="text-body-1 font-weight-medium">{{ $getDeepObj(item, 'sekolah.nama') }}</div>
                      <div class="text-body-2">
                        NPSN: <span class="font-weight-medium">{{ $getDeepObj(item, 'sekolah.npsn') }}</span>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="4"
                      v-for="(peserta, key) in item.peserta || item.psp_pelatihan_kandidats || []"
                      :key="key"
                    >
                      <v-label color="caption">
                        <small>Peserta {{ Number(key) + 1 }}</small>
                      </v-label>
                      <div class="text-body-1 font-weight-medium">{{ $getDeepObj(peserta, 'ptk.nama') }}</div>
                      <div class="text-body-2">
                        SIMPKB ID: <span class="font-weight-medium">{{ $getDeepObj(peserta, 'ptk_id') }}</span>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action class="my-auto">
                  <v-btn color="error" depressed @click="onDelete(id)"><v-icon>mdi-close</v-icon></v-btn>
                </v-list-item-action>
              </v-list-item>
            </div>
          </v-list>
        </v-container>
      </v-card-text>
    </v-card>
    <candidate-sekolah ref="kandidat" :masters="masters" />
  </div>
</template>
<script>
import CandidateSekolah from '../popup/Peserta.vue';
export default {
  components: { CandidateSekolah },
  props: {
    initValue: {
      type: [Object, Array],
      default: () => null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
    min: {
      type: [String, Number],
    },
    max: {
      type: [String, Number],
    },
  },
  data() {
    return {
      form: [],
      sekolah: [],
      maxLabel: 15,
    };
  },
  computed: {},
  methods: {
    reset() {
      this.$set(this, 'form', []);
      this.$set(this, 'sekolah', []);
    },

    initForm(value) {
      if (!value) return;

      for (const item of value) {
        this.sekolah.push(item);
        this.form.push(item.sekolah_id);
      }
    },

    getValue() {
      return this.form;
    },

    onAdd() {
      this.$refs.kandidat.open(this.form).then((resp) => {
        resp.forEach((item) => {
          this.sekolah.push(item);
          this.form.push(item.sekolah_id);
        });
      });
    },

    onDelete(id) {
      this.sekolah.splice(id, 1);
      this.form.splice(id, 1);
    },
  },

  watch: {
    initValue: 'initForm',
  },
};
</script>
